import { render } from "./cb6fc894-1449-11eb-8116-00155d01060e.vue?vue&type=template&id=4770942d"
import script from "./cb6fc894-1449-11eb-8116-00155d01060e.vue?vue&type=script&lang=js"
export * from "./cb6fc894-1449-11eb-8116-00155d01060e.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__